import React, { useEffect, useMemo, useState } from 'react';
import { useTradeForm } from '../hooks/useTradeForm';
import { TradeAssetsPageSchema } from '@shared/zod-schemas/frontend';
import { toast } from 'sonner';
import { AlertCircle, CircleCheck, CircleX, Settings } from 'lucide-react';
import { useSwap } from '@/contexts/SwapProvider';
import { useRouter } from 'next/router';
import { Form } from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { BuySellAssetControllerStages } from '@shared/types/frontend/assetPage';
import TradeAmountInput from './TradeAmountInput';
import SelectFromToTrade from './SelectFromToTrade';
import { useSession } from '@/contexts/LitSessionProvider';
import { validate } from '../../swap-home/const';
import { CovalentBalanceItem } from '@shared/types/frontend';
import PreSwapConfirmationModal from '../../swap-home/PreSwapConfirmationModal';
import SwapSettings from '../../mobile/SwapSettings';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { watch } from 'fs';
import DesktopGuard from '@/components/auth/desktop/DesktopGuard';
const SwapController = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const _handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
    return;
  };
  const router = useRouter();
  const {
    PKP
  } = useSession();
  const {
    refetch: refetchBalances
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const {
    form,
    refetchOrderHistory,
    assetData,
    handleOnSwitchTokenSides
  } = useTradeForm();
  const {
    swapResult,
    swapLoading,
    resetAssets,
    fromAssets,
    toAssets
  } = useSwap();
  const [_formWatch, _watchUsdAmount, _watchFromToken, _watchToToken] = [form.watch(), form.watch('usdAmount'), form.watch('fromToken'), form.watch('toToken')];
  //todo update, hack b/c state is not dependent on useSwap
  useEffect(() => {
    if (!fromAssets.length && !toAssets.length) {
      //clear form
      console.log('setting to token clearing form');
      form.reset();
    }
  }, [fromAssets, toAssets]);
  console.log('toAsswefwefets', toAssets);

  // on executing swap
  useEffect(() => {
    // swap success
    if (swapResult?.order_id) {
      form.reset();
      resetAssets();
      refetchOrderHistory();
      refetchBalances();
      router.push({
        pathname: `/trade`
      }, undefined, {
        shallow: true
      });
      return;
    }
    return () => {};
  }, [swapResult, swapLoading]);
  const _validateFromAndToAssets = useMemo(() => {
    if (_watchFromToken && _watchToToken && _watchUsdAmount) {
      const _validate = validate([{
        ...(_watchFromToken as CovalentBalanceItem),
        amountToUseStr: _watchUsdAmount,
        amountToUse: Number(_watchUsdAmount)
      }], [_watchToToken]);
      return _validate;
    }
    return {
      valid: false,
      error: ''
    };
  }, [_watchFromToken, _watchToToken, _watchUsdAmount]);

  // console.log('WUJI from & to', fromAssets, toAssets);
  const [slippageOpen, setSlippageOpen] = useState(false);
  console.log('toTokneaesfgw', _watchToToken);
  return <>
      <SwapSettings isModalOpen={slippageOpen} toggleModal={() => setSlippageOpen(!slippageOpen)} data-sentry-element="SwapSettings" data-sentry-source-file="SwapController.tsx" />
      <Form {...form} data-sentry-element="Form" data-sentry-source-file="SwapController.tsx">
        <form className='grid gap-2 w-[572px] h-fit' onSubmit={e => e.preventDefault()}>
          <>
            <div className='grid content-start gap-6 py-4 h-[287px] rounded-3xl bg-genius-indigo border border-genius-blue genius-shadow'>
              <Button type='button' variant='outline' className='rounded-full h-[34px] w-[97px] text-genius-cream p-2 border-genius-blue flex gap-1 place-self-center' onClick={() => {
              setSlippageOpen(true);
            }} data-sentry-element="Button" data-sentry-source-file="SwapController.tsx">
                <p>Settings</p>
                <Settings size={14} data-sentry-element="Settings" data-sentry-source-file="SwapController.tsx" />
              </Button>
              <TradeAmountInput form={form} assetData={assetData} data-sentry-element="TradeAmountInput" data-sentry-source-file="SwapController.tsx" />
            </div>

            <DesktopGuard data-sentry-element="DesktopGuard" data-sentry-source-file="SwapController.tsx">
              <SelectFromToTrade form={form} assetData={assetData} handleOnSwitchTokenSides={handleOnSwitchTokenSides} data-sentry-element="SelectFromToTrade" data-sentry-source-file="SwapController.tsx" />
            </DesktopGuard>
            <div className='grid gap-4'>
              {/* validation error message */}
              {Boolean(_validateFromAndToAssets?.error !== '' && _validateFromAndToAssets?.error !== 'Swap') && <div className='flex gap-2 items-center justify-center'>
                    <AlertCircle className='text-yellow-400/70' />
                    <span className='text-sm text-genius-cream/70'>
                      {_validateFromAndToAssets.error}
                    </span>
                  </div>}
            </div>
          </>

          {!!fromAssets?.length && !!toAssets?.length && validate(fromAssets, toAssets).valid && <div className='bg-genius-indigo border-genius-blue border-[1px] rounded-3xl genius-shadow py-4 px-2'>
              <PreSwapConfirmationModal onClickBack={() => true} />
            </div>}
        </form>
      </Form>
    </>;
};
export default SwapController;